import React from 'react';

import classNames from 'classnames';

import { useTrans } from '@/custom-hooks/useTrans';

import { ModuleRoute } from '@modules/utils/module-interfaces';

import { injectStores } from '@stores/factories/store-utils';
import { TypeApplicationStore } from '@stores/application-store';

import { useWindowSize } from '../../../custom-hooks';

import ModuleNavigation from '../../modules/module-navigation';
import PsbComponent from '@components/atoms/psb-component/psb-component';
import SwitchLink from '../menu/switch-link/switch-link';

import './footer.scss';

interface Props {
    ApplicationStore: TypeApplicationStore;
    minimal?: boolean;
}

function Footer(props: Props) {
    const { t } = useTrans();
    const {
        ApplicationStore: { serverDate },
        minimal = false,
    } = props;
    const { isSmallScreen } = useWindowSize();

    const currentYear = new Date(serverDate).getFullYear() || new Date().getFullYear();

    const footerHeaderClass = classNames('footer-header', { 'display-block': isSmallScreen });

    if (minimal) {
        return (
            <footer id='jakhub-footer' className='footer'>
                <div className='footer-content container' style={{ placeItems: 'center' }}>
                    <div className='legal-menu'>
                        <div className='full-menu__legal'>
                            <ModuleNavigation
                                className='footer-legal'
                                selectedModules={['LEGAL']}
                            />
                        </div>
                        <div className='copyright'>
                            {t('footer:module.copyright.menu-label', {
                                AK_VAR_CURRENT_YEAR: currentYear,
                                AK_ICP_LINK: (
                                    <SwitchLink
                                        akTestId='ICP|WWW.BEIAN.GOV.CN'
                                        to='https://www.beian.gov.cn'
                                    />
                                ),
                                AK_PSB_LINK: <PsbComponent />,
                            })}
                        </div>
                    </div>
                </div>
            </footer>
        );
    }

    return (
        <footer id='jakhub-footer' className='footer'>
            <nav className='footer-content container'>
                <div className={footerHeaderClass}>
                    <div className='footer-header__link'>
                        <ModuleNavigation
                            className='footer-home'
                            selectedModules={['HOME']}
                            predicate={(module: ModuleRoute) => module.id === 'FOOTER_HOME'}
                            // useIcon
                        />
                    </div>
                    <div className='text-links'>
                        <ModuleNavigation
                            className='footer-text-links'
                            selectedModules={['FOOTER']}
                            predicate={(module: ModuleRoute) =>
                                !module.IconComponent &&
                                module.displayInMenu !== false &&
                                module.displayInFooter !== false
                            }
                        />
                    </div>
                    <div className='icon-links'>
                        <ModuleNavigation
                            className='footer-icon-links'
                            selectedModules={['FOOTER']}
                            predicate={(module: ModuleRoute) =>
                                !!module.IconComponent &&
                                module.displayInMenu !== false &&
                                module.displayInFooter !== false
                            }
                            // useIcon
                        />
                    </div>
                </div>
                <div className='full-menu'>
                    <ModuleNavigation
                        className='footer-full-menu'
                        predicate={(module: ModuleRoute) =>
                            module.displayInMenu !== false && module.displayInFooter !== false
                        }
                    />
                </div>
                <div className='legal-menu'>
                    <div className='full-menu__legal'>
                        <ModuleNavigation className='footer-legal' selectedModules={['LEGAL']} />
                    </div>
                    <div className='copyright'>
                        {t('footer:module.copyright.menu-label', {
                            AK_VAR_CURRENT_YEAR: currentYear,
                            AK_ICP_LINK: (
                                <SwitchLink
                                    akTestId='ICP|WWW.BEIAN.GOV.CN'
                                    to='https://www.beian.gov.cn'
                                />
                            ),
                            AK_PSB_LINK: <PsbComponent />,
                        })}
                    </div>
                </div>
            </nav>
        </footer>
    );
}

export default injectStores(['ApplicationStore'])(Footer);
